import React, { Component, useCallback, useEffect, useState, forwardRef, useImperativeHandle  } from 'react';
import {
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';
import i18n from "../../i18n";


import { View, Text, Image, ActivityIndicator} from "react-native-web";

import SearchBoxMobile from "./SearchBoxMobile";

import HamburgerMenu from 'react-hamburger-menu';

import userStore from '../../store/userStore';


const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;


const HeaderMobile = forwardRef((props, ref) => {

  const [open, setOpen] = useState(false);
  const [view, setView] = useState('mini');

  const currentYear = new Date().getFullYear();

   const navigate = useNavigate();

   const location = useLocation();

   const isRoot = location.pathname === '/';
   const isHome = location.pathname === '/home';
   const isAbout = location.pathname === '/about';

   let pathname = location.pathname;


   let _user = null, thumbnailURL = '';
   if (props.isSignedin)
   {
      _user = JSON.parse(props.sinUser);

     thumbnailURL = _user.thumbnail;
   }


   const [thumbnail, setThumbnail] = useState(thumbnailURL);


   const user = _user;



   const handleNewUserURLStore = useCallback((url) => {
     setThumbnail(url)
     // ... logique de traitement ici
   //  alert('Handling reaction store update:' + JSON.stringify(h));
   }, []);

   useEffect(() => {
     // Enregistrement du handler
     userStore.getState().registerHandler(handleNewUserURLStore);

     // Nettoyage au démontage
     return () => {
       userStore.getState().unregisterHandler?.(handleNewUserURLStore);
     };
   }, [handleNewUserURLStore]);


   const signOut = () => {

     localStorage.removeItem('storrypagejwtToken');
     localStorage.removeItem('storrypageUser');

     setTimeout(() => {
        window.location = "/";
     },100);


   }


   const handleClick = () => {
       let bool = !open;
       setOpen(bool);

       props.handleMenuClick(bool);
   }

   useImperativeHandle(ref, () => ({
       closeMenu: () => {
           setOpen(false);
       }
   }));

   const setLocale = (lang) => {



          localStorage.setItem("language", lang);
          i18n.changeLanguage(lang);


   }


   const handleSearchChange = (query, objects) => {
      props.handleSearchChange(query, objects);
   }


   const handleSearchView = (view) => {
     setView(view);
     //props.handleSearchView(view);
   }




    return (

      <div className="main_header" style={{zIndex: 29, top: 0, left: 0, right: 0, width: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)'}}>

             {props.isSignedin &&
              <div className="main_header_inside">

                  <div className="main_header_inside_left" style={{display: view === 'large' ? 'none':'flex', marginLeft: '-20px', marginTop: '5px'}}>
                     <a href="/"><img src={'/img/storrypage_logo_trans.png'} alt="StorryPage Logo" style={{width: '120px'}}/></a>
                  </div>


                  {viewportWidth > 375 &&
                    <div className="main_header_inside_left_2" style={{marginLeft: '-10px', display: view === 'large' ? 'none':'flex', lineHeight: '65px'}}>
                      <a href="/" style={{fontSize: '15px', fontWeight: isRoot ? 'bold':'normal'}}>{i18n.t('Home')}</a>
                    </div>
                 }






                  <div className="main_header_inside_right_1" style={{marginLeft: '50px', marginRight: '10px', display: view === 'large' ? 'none':'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>

                          <a href="/myaccount">
                             <View style={{cursor: 'pointer', width: '42px', height: '48px', justifyContent: 'center'}}>
                                {user !== null && <Image source={{uri: thumbnail}} style={{width: '40px', height: '40px', borderRadius: '20px', border: '1px solid #999'}}/>}
                            </View>
                          </a>

                            <View style={{cursor: 'pointer', marginLeft: '20px', marginTop: '0px', width: '40px', height: '48px', justifyContent: 'center'}}>

                           <HamburgerMenu
                                isOpen={open}
                                menuClicked={handleClick}
                                width={40}
                                height={25}
                                strokeWidth={2}
                                rotate={0}
                                color='#0b49ff'
                                borderRadius={0}
                                animationDuration={0.5}
                               />

                              </View>
                  </div>




                  <div className="main_header_inside_right_1" style={{float: 'right', marginTop: 0, color: '#333'}}>
                      <SearchBoxMobile handleSearchChange={handleSearchChange} handleSearchView={handleSearchView}/>
                  </div>


                  <div style={{clear: 'both'}}/>

                </div>
              }


              {!props.isSignedin &&
               <div className="main_header_inside">

                   <div className="main_header_inside_left" style={{display: view === 'large' ? 'none':'flex', marginLeft: '-20px', marginTop: '5px'}}>
                      <a href="/"><img src={'/img/storrypage_logo_trans.png'} alt="StorryPage Logo" style={{width: '120px'}}/></a>
                   </div>


                   <div className="main_header_inside_left_2" style={{display: view === 'large' ? 'none':'flex', marginLeft: '-10px', lineHeight: '65px'}}>
                       <a href="/" style={{fontSize: '15px', fontWeight: isRoot ? 'bold':'normal'}}>{i18n.t('Home')}</a>
                    </div>




                   <div className="main_header_inside_right_1" style={{display: view === 'large' ? 'none':'flex', marginTop: '17px', marginRight: '10px'}}>
                            <HamburgerMenu
                                 isOpen={open}
                                 menuClicked={handleClick}
                                 width={40}
                                 height={25}
                                 strokeWidth={2}
                                 rotate={0}
                                 color='#0b49ff'
                                 borderRadius={0}
                                 animationDuration={0.5}
                                />
                   </div>


                   <div className="main_header_inside_right_1" style={{display: view === 'large' ? 'none':'flex', marginRight: '15px', position: 'relative', flexDirection: 'row', justifyContent: 'flex-end'}}>






                        <a href="/signin">
                           <View style={{display: 'none', cursor: 'pointer', marginLeft: '40px', marginTop: '5px', backgroundColor: '#fff', width: '120px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                               borderWidth: 1, borderColor: '#fff'}}>
                              {i18n.language == 'en' && <Text style={{fontSize: '17px', color: '#000', textAlign: 'center', fontFamily: 'Roboto',}}>{`Sign in`}</Text>}
                              {i18n.language == 'fr' && <Text style={{fontSize: '17px', color: '#000', textAlign: 'center', fontFamily: 'Roboto',}}>{`Se connecter`}</Text>}
                           </View>
                         </a>

                       <a href="/signup">
                         <View style={{display: 'none', cursor: 'pointer', marginLeft: '20px', marginTop: '5px', width: '120px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                                    borderWidth: 1, borderColor: '#fff'}}>
                             {i18n.language == 'en' && <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center', fontFamily: 'Roboto',}}>{`Sign up`}</Text>}
                             {i18n.language == 'fr' && <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center', fontFamily: 'Roboto',}}>{`S'enregistrer`}</Text>}
                         </View>
                      </a>

                   </div>


                   <div className="main_header_inside_right_1" style={{float: 'right', marginTop: 0, color: '#333'}}>
                       <SearchBoxMobile handleSearchChange={handleSearchChange} handleSearchView={handleSearchView}/>
                   </div>




                   <div style={{clear: 'both'}}/>

                 </div>
               }

      </div>

    )

});

export default HeaderMobile;
